<template>
    <div>
        <div class="row">
            <div class="col"><button @click="goBack()" class="btn btn-secondary m-3">Back</button></div>
        </div>
        <div class="row align-items-center m-3">
            <div class="col">
                <div>
                    <p class="h1 t-race"> {{this.getReportName}} </p>
                </div>
            </div>
        </div>
        <div class="row align-items-center m-3">
            <div class="col">
                <div>
                    
                    <div class="dropdown show">
                        <a class="btn btn-secondary dropdown-toggle" @click="toggleDropdown()" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          EXPORT
                        </a>
                      
                        <div v-bind:class="dropdownToggle" aria-labelledby="dropdownMenuLink">
                          <a @click="openLink('CSV')" class="dropdown-item" href="#">CSV</a>
                          <a @click="openLink('XL')" class="dropdown-item" href="#">Excel</a>
                          
                        </div>
                      </div>

                </div>
            </div>
        </div>
        
            <div class="displayBox table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            
                            <th scope="col" v-for="(item , index) in getCleanReportHeaders()" :key="index">{{headerNameSantizer(item)}}</th>
                            

                        </tr>
                    </thead>
                    <tbody>
                       <tr v-for="(item , index) in getReportSectional" :key="index">
                            <td v-for="(val , index)  in columnsDisplayCleaner(item)" :key="index">
                                
                               <template v-if="val.isGroup">
                                <div>
                                    <div class="horse-details">
                                        <div class="horse-name-area">
                                            {{ val.value }} 
                                        </div>
                                        
                                        <div class="trainer-jockey-area">
                                            <div class="trainer">{{  val.groupValues.Jockey }}{{val.groupValues.Trainer == null ? '':'/' }}{{  val.groupValues.Trainer }}</div>                                      
                                        </div> 
                                    </div> 
                                </div>
                               </template>
                               <template v-else>
                                {{  val.value }} 
                               </template>
                            </td>

                       </tr>


                    </tbody>
                </table>
            </div>
        
        
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import { config } from '../../config';

export default {
name:"SectionalDistanceCoveredReport" , 
data() {
    return {
        dropdownToggle:'dropdown-menu' , 
            dropdownStatus : false 
    }
},
methods: {
    goBack(){
        this.$router.push('/landing/SectionalDistanceCoveredFilter');
    }  , 
    getCleanReportHeaders(){
        let HeaderArray  = [] ; 
        let ValidPush = true ; 
        this.getReportSectionalHeaders[0].raceHeaders.forEach((item) => {
            if(item == "MeetingDate"){
               ValidPush = false ; 
            }
            if(item == "Race"){
                ValidPush = false ; 
            }
            if(item == "RaceCourse"){
                ValidPush = false ; 
            }
            if(item == "Jockey"){ValidPush=false}
            if(item == "Trainer"){ValidPush=false}
            if(item =="WeightAllowed"){ValidPush =  false}
            
           
            if(ValidPush){
                HeaderArray.push(item) ; 
            }

            ValidPush = true ; 

             

        })
        

        return HeaderArray ; 


    } , 

    toggleDropdown(){
            this.dropdownStatus = !this.dropdownStatus ; 
            this.dropdownToggle = this.dropdownStatus ? "dropdown-menu show" :"dropdown-menu" ; 
        },
    columnsDisplayCleaner(row){
        var tempArray = []  ; 
        // eslint-disable-next-line no-console
        let tempRow  =  Object.assign({} , row) ; 
        // eslint-disable-next-line no-console
        var  t = this.dateHeader(tempRow.meetingDate) ; 
     
        tempRow.meetingDate = t ; 
        delete tempRow.meetingDate ;
        delete tempRow.race;
        delete tempRow.raceCourse; 
        
       
        var tempJockeyAndTrainerDetails = {
            "Jockey":tempRow.jockey , 
            "Trainer":tempRow.trainer 
        }
        delete tempRow.jockey ; 
        delete tempRow.trainer;

        var tempWeightAllowedAltered = {
            "Jockey":tempRow.weightAllowed, 
            "Trainer":null 
        }

        delete tempRow.weightAllowed ; 
        row = tempRow ;

        
        for(var key in row){
            // eslint-disable-next-line no-console
            if(this.getReportSectionalHeaders[0].raceHeaders.filter(x => x.toLowerCase() == key.toLowerCase()).length > 0 ){
               
               
                if (key == "horse" | key == "weight"){  
                    if(key == "weight"){
                        tempArray.push({
                            "value" :row[key] ,
                            "isGroup" : true,
                            "groupValues":tempWeightAllowedAltered
                        })
                    }

                    if(key =="horse"){
                        tempArray.push({
                        "value" :row[key] ,
                        "isGroup" : true,
                        "groupValues": tempJockeyAndTrainerDetails
                    }); 
                    }   

                }else{
                    tempArray.push({
                    "value" :row[key]  ,
                    "isGroup" : false
                }); 
                }
            }
        }
        // eslint-disable-next-line no-console
       
        return tempArray ;




    } , titleCleaner(title){

        return title.replaceAll("$$" , this.getReportSectional[0].race);


    } , 
    dateHeader(mdate ){
        // eslint-disable-next-line no-console
        var validDate  = new Date(mdate) ;
       
        var month = validDate.getMonth()+1; 
        var day  = validDate.getDate() ; 
        var year = validDate.getFullYear(); 
        
            return `${year}-${month >= 9  ? month : `0${month}`}-${day >= 9 ? day : `0${day}`}` ;  

        } , 

    openLink(fileType){
        
        window.open(`${config.reportingURL}/api/Reports/FileDistanceCovered?raceCourse=${this.getReportSectional[0].raceCourse}&startDate=${this.getReportSectional[0].meetingDate}&raceNumber=${this.getReportSectional[0].race}&fileType=${fileType}`, '_blank');


    },


    headerNameSantizer(colName){
        

        return colName.replaceAll("_" ,"") ; 
    }
},
computed: {
        ...mapGetters([
            'getReportSectional' , 'getReportSectionalHeaders' , 'getReportName'
        ])
    }

}



</script>

<style scoped>


.horse-details{
    display: flex;
    flex-direction: column;
}
.trainer-jockey-area{
    display: flex;
    flex-direction: row;
    font-style: italic;
    color: grey;
    margin-inline:auto ; 
    
}
.trainer,.jockey{
    padding-inline: 0.3rem;
    font-size: 0.69rem;
}
.trainer{
    padding-right: 0.5rem;
}

.displayBox{
    max-height: 80vh;
    width: 95%;
    overflow: scroll;
    margin-inline: auto;

}
th {
    color: white !important;
    text-align: center;
    font-weight: bold;
    background-color: #4CAEE3 !important;
}
tr:hover{
    background-color: black;
    color: white;
}
.t-race {
    text-align: center;
}

td {
    text-align: center;
    padding: 0px;
    padding-inline: 0.5rem;
}

.container {
    width: 100% !important;
}



</style>